// Auto generated file, do not manually modify!
// com.hotpads.listingdatamodeltypes.enums.screeningcriteria.ScreeningCriteriaType

export enum ScreeningCriteriaType {
  ADDITIONAL = 'ADDITIONAL',
  CREDIT_SCORE_MIN = 'CREDIT_SCORE_MIN',
  EVICTION_HISTORY = 'EVICTION_HISTORY',
  INCOME_TO_RENT_RATIO = 'INCOME_TO_RENT_RATIO',
  PET_POLICY_CAT_COUNT = 'PET_POLICY_CAT_COUNT',
  /**
   * @deprecated
   */
  PET_POLICY_DOG_COUNT = 'PET_POLICY_DOG_COUNT',
  /**
   * @deprecated
   */
  PET_POLICY_DOG_SIZE = 'PET_POLICY_DOG_SIZE',
  PET_POLICY_LARGE_DOG_COUNT = 'PET_POLICY_LARGE_DOG_COUNT',
  PET_POLICY_OTHER_PETS = 'PET_POLICY_OTHER_PETS',
  PET_POLICY_PET_DEPOSIT = 'PET_POLICY_PET_DEPOSIT',
  PET_POLICY_PET_RENT = 'PET_POLICY_PET_RENT',
  PET_POLICY_SMALL_DOG_COUNT = 'PET_POLICY_SMALL_DOG_COUNT',
  RENTAL_ARREARS = 'RENTAL_ARREARS',
  RENTAL_HISTORY_MIN = 'RENTAL_HISTORY_MIN',
}

export const ScreeningCriteriaType_values = [
  ScreeningCriteriaType.ADDITIONAL,
  ScreeningCriteriaType.CREDIT_SCORE_MIN,
  ScreeningCriteriaType.EVICTION_HISTORY,
  ScreeningCriteriaType.INCOME_TO_RENT_RATIO,
  ScreeningCriteriaType.PET_POLICY_CAT_COUNT,
  ScreeningCriteriaType.PET_POLICY_DOG_COUNT,
  ScreeningCriteriaType.PET_POLICY_DOG_SIZE,
  ScreeningCriteriaType.PET_POLICY_LARGE_DOG_COUNT,
  ScreeningCriteriaType.PET_POLICY_OTHER_PETS,
  ScreeningCriteriaType.PET_POLICY_PET_DEPOSIT,
  ScreeningCriteriaType.PET_POLICY_PET_RENT,
  ScreeningCriteriaType.PET_POLICY_SMALL_DOG_COUNT,
  ScreeningCriteriaType.RENTAL_ARREARS,
  ScreeningCriteriaType.RENTAL_HISTORY_MIN,
] as const;
